import { MetadataFieldRendererProps } from '@/asset/components/metadata/field-renderer';
import { Checkbox, FormControlLabel, Paper, Typography } from '@mui/material';
import { FieldValues, useFormContext, useWatch } from 'react-hook-form';

/**
 * Renders a boolean field in the metadata form.
 *
 * IMPORTANT: This component must be wrapped in a FormProvider from react-hook-form.
 */
export function BooleanFieldRenderer(props: MetadataFieldRendererProps) {
  const { metadata, setValue, fieldIndex } = props;
  const { control } = useFormContext<FieldValues>();
  const value = useWatch({
    control,
    name: `metadata.${fieldIndex}.value`,
  });
  return (
    <Paper
      variant="outlined"
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <FormControlLabel
        control={
          <Checkbox
            key={metadata.field.key}
            checked={value === 'true' || value === true}
            onChange={(e) => {
              setValue(e.target.checked);
            }}
          />
        }
        label={<Typography variant="body2">{metadata.field.label}</Typography>}
        sx={{
          margin: 0,
          width: '100%',
        }}
      />
    </Paper>
  );
}
